import { FormattedMessage } from 'react-intl'
import { target } from '../../utils'
import PriceConverter from '../helpers/PriceConverter'
import PromotionLabel from '../helpers/PromotionLabel'
import TwoDatesFormat from '../helpers/TwoDatesFormat'

export default function OperatorCard({ shop, handleClick }) {
  return (
    <div className='operator-item-wrapper' key={shop.url} onClick={handleClick}>
      <a
        className='operator-item-card bordered-element'
        href={shop.url}
        target={target}
      >
        <div className='img-wrapper'>
          <img
            className='img'
            src={shop.backgrounds.DOSliderMobileLand}
            loading='lazy'
          />
        </div>

        <div className='info'>
          <strong className='shop-title'>{shop.shopTitle}</strong>
          <ul className='features'>
            <li>
              <i className='font-icons location-icon' />
              {shop.areaTitle}, {shop.countryTitle}
            </li>
            <li>
              <i className='font-icons dive-center-icon' />
              {shop.numberOfDivesMax ? (
                <FormattedMessage
                  id='including_dives_min_max'
                  defaultMessage='Including { divesMin } - { divesMax } dives'
                  values={{
                    divesMin: shop.numberOfDivesMin,
                    divesMax: shop.numberOfDivesMax,
                  }}
                />
              ) : (
                <FormattedMessage
                  id='including_dives_min'
                  defaultMessage='Including { divesMin } dives'
                  values={{
                    divesMin: shop.numberOfDivesMin,
                  }}
                />
              )}
            </li>
            <li>
              <i className='font-icons calendar-icon' />
              <TwoDatesFormat dateFrom={shop.dateFrom} dateTo={shop.dateTo} />
            </li>
          </ul>
        </div>
        {shop.availableSpots ? (
          <div className='price-wrap'>
            <PromotionLabel
              promotion={shop.promotion}
              currency={shop.currency}
              price={shop.price}
              compareAtPrice={shop.compareAtPrice}
              showComparePrice
            />
            <span className='price'>
              <PriceConverter amount={shop.price} currency={shop.currency} />
            </span>
            <div className='price-details'>
              <span className='price-type'>
                <FormattedMessage
                  id='per_person_for_nights'
                  values={{
                    duration: shop.duration,
                  }}
                  defaultMessage='per person for { duration } nights'
                />
              </span>
              {shop.availableSpots < 5 ? (
                <span className='spots-left'>
                  <FormattedMessage
                    id='spots_left_only'
                    values={{
                      qty: shop.availableSpots,
                    }}
                    defaultMessage='Only { qty } left'
                  />
                </span>
              ) : (
                ''
              )}
            </div>
          </div>
        ) : (
          <div className='price-wrap'>
            <div className='sold-out'>
              <i className='font-icons fail-icon-new' />{' '}
              <FormattedMessage id='sold-out' defaultMessage='Sold out' />
            </div>
          </div>
        )}
      </a>
    </div>
  )
}
